// extracted by mini-css-extract-plugin
module.exports = {"registerFormContainer":"register_registerFormContainer__mS8zH"};